import script from "./TotalsDoughnutChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./TotalsDoughnutChart.vue?vue&type=script&lang=ts&setup=true"

import "./TotalsDoughnutChart.vue?vue&type=style&index=0&id=32732da9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32732da9"]])

export default __exports__